import React from 'react';
import giftbox from '../../assets/images/giftbox.png'; // 导入图片
import './Wallet.css'; // 引入自定义 CSS 文件以支持动画

const Wallet = () => {
  const coins = [
    { x: 'calc(-100px + 24px)', y: 'calc(-105px + 24px)', delay: '0.3s' },
    { x: 'calc(-70px + 24px)', y: '-90px', delay: '0.1s' },
    { x: 'calc(-30px + 24px)', y: '-125px', delay: '0s' },
    { x: 'calc(10px + 24px)', y: '-130px', delay: '0.2s' },
    { x: 'calc(30px + 24px)', y: '-100px', delay: '0.1s' },
    { x: 'calc(70px + 24px)', y: '-95px', delay: '0.4s' },
    { x: 'calc(100px + 24px)', y: '-100px', delay: '0.2s' },
  ];

  return (
    <div className="flex justify-center ">
      <div className="relative w-32 h-32 translate-x-6 translate-y-4" id="wallet">
        {/* 替换 SVG 为图片 */}
        <div className="w-full h-full flex items-center justify-center rounded-full relative z-[101]">
          <img
            src={giftbox}
            alt="Giftbox"
            className="w-28 h-28 object-contain -translate-y-6"
          />
        </div>
        {/* 动画硬币 */}
        {coins.map((coin, index) => (
          <div
            key={index}
            className="coin absolute top-[72px] left-[48px] z-[103] opacity-0"
            style={{
              '--coin-to-x': coin.x,
              '--coin-to-y': coin.y,
              '--coin-delay': coin.delay,
              '--coin-duration': '1.5s',
            }}
          >
            <div className="coin-after flex items-center justify-center w-3 h-3 text-[10px] text-[#edc46b] bg-[#e3a217] border-2 border-[#edc46b] rounded-full opacity-0">
              W3
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Wallet;